const defaultStarred = []

const initialState = {
  filter: '%25',
  skip: 0,
  activePage: 1,
  initRange: 0,
  endRange: 100000000,
  group: '0',
  orderby: 0,
  produtos: [],
  qtdItens: 0
}

const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        filter: action.payload,
        skip: 0,
        activePage: 1
      }
    case "SET_ACTIVE_PAGE":
      return {
        ...state,
        activePage: action.payload,
        skip: action.payload-1
      }
    case 'SET_RANGE':
      return {
        ...state,
        initRange: action.payload.split(',')[0],
        endRange: action.payload.split(',')[1],
        skip: 0,
        activePage: 1
      }
    case 'SET_GROUP':
      return {
        ...state,
        group: action.payload,
        skip: 0,
        activePage: 1
      }
    case 'SET_PRODUTOS':
      return {
        ...state,
        produtos: action.payload,
      }
    case 'SET_ORDERBY':
      return {
        ...state,
        orderby: action.payload
      }
    case 'RESETAR_FILTROS':
      return {
        ...state,
        produtos: action.payload,
        filter: '%25',
        skip: 0,
        activePage: 1,
        initRange: 0,
        endRange: 100000000,
        group: '0'
      }
    case 'SET_QTDITENS':
      return {
        ...state,
        qtdItens: action.payload
      }

    default:
      return state
  }
}

export default shopReducer
